
<style scoped>

</style>

<template>

<div>

sschan

</div>

</template>


<script>

export default{
    data:function(){
        return {

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/sschan/main.vue